interface MetricCardProps {
  label: string;
  value: string | number;
  sub?: string;
}

export default function MetricCard({ label, value, sub }: MetricCardProps) {
  return (
    <div className="card p-5">
      <p className="text-xs text-faint mb-1">{label}</p>
      <p className="text-2xl font-extrabold text-ink">{value}</p>
      {sub && <p className="text-xs text-faint mt-1">{sub}</p>}
    </div>
  );
}
